export function toFileMultiValue(data) {
  return {
    item: {
      ...data,
      id: data.file_id || data.id,
      value: data.name,
    },
  }
}
